/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import { Fade } from 'react-awesome-reveal';
import Button from 'elements/Button';
import { useLanguage } from '../contexts/LanguageContext.js';

export const DiscussForm = () => {
  const { t } = useLanguage();

  return (
    <section className="flex flex-col container mx-auto mt-10 mb-20 justify-center px-4">

      <Fade direction="down" triggerOnce>
        <h1 className="text-4xl md:text-5xl text-white text-center font-bold mb-4">
          {t('contactTitle') || 'Kontak Kami'}
        </h1>
      </Fade>

      <Fade direction="up" triggerOnce>
        <p className="font-light text-base md:text-lg text-white text-center mb-12">
          {t('contactSubtitle') || 'Hubungi kami untuk informasi lebih lanjut tentang produk dan layanan kami'}
        </p>
      </Fade>

      <Fade direction="up" triggerOnce delay={200}>
        <div className="flex flex-col md:flex-row gap-8 justify-center items-start max-w-6xl mx-auto">
          
          {/* Address Section */}
          <div className="flex-1 bg-white bg-opacity-90 rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="flex items-center mb-6">
              <div className="bg-green-700 rounded-full p-4 mr-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-green-900">
                {t('address') || 'Alamat'}
              </h2>
            </div>
            <div className="space-y-3 text-green-950">
              <p className="text-lg font-semibold">Menara BRI Bandung, Lantai 11</p>
              <Button 
                href="https://maps.app.goo.gl/TeJf5gKhhWkTqdxw8" 
                type="link" 
                target="_blank" 
                className="block text-base hover:text-green-700 hover:underline transition-colors"
                isExternal
              >
                Jl. Asia Afrika No.57, Braga,<br />
                Kec. Sumur Bandung,<br />
                Kota Bandung, Jawa Barat 40251
              </Button>
              <Button 
                href="https://maps.app.goo.gl/TeJf5gKhhWkTqdxw8" 
                type="link" 
                target="_blank" 
                className="inline-flex items-center mt-4 px-6 py-3 bg-green-700 text-white rounded-full hover:bg-green-800 transition-colors font-semibold"
                isExternal
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
                {t('viewOnMaps')}
              </Button>
            </div>
          </div>

          {/* Contact Info Section */}
          <div className="flex-1 bg-white bg-opacity-90 rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="flex items-center mb-6">
              <div className="bg-green-700 rounded-full p-4 mr-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-green-900">
                {t('contactInfo') || 'Informasi Kontak'}
              </h2>
            </div>
            <div className="space-y-4">
              {/* Email */}
              <Button 
                href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@bulindoagroteknologi.com" 
                type="link" 
                target="_blank" 
                className="flex items-center p-4 bg-gray-50 rounded-xl hover:bg-green-50 transition-all group"
                isExternal
              >
                <img 
                  style={{ width: 24, height: 24, marginRight: 12 }} 
                  src="/assets/images/gmail.png" 
                  alt="Gmail" 
                  className="group-hover:scale-110 transition-transform"
                />
                <div>
                  <p className="text-xs text-gray-600 uppercase tracking-wider">Email</p>
                  <p className="text-sm font-bold text-green-950 group-hover:text-green-700">
                    sales@bulindoagroteknologi.com
                  </p>
                </div>
              </Button>

              {/* WhatsApp */}
              <Button 
                href="https://wa.me/6281212345678" 
                type="link" 
                target="_blank" 
                className="flex items-center p-4 bg-gray-50 rounded-xl hover:bg-green-50 transition-all group"
                isExternal
              >
                <img 
                  style={{ width: 24, height: 24, marginRight: 12 }} 
                  src="/assets/images/whatsapp.png" 
                  alt="WhatsApp" 
                  className="group-hover:scale-110 transition-transform"
                />
                <div>
                  <p className="text-xs text-gray-600 uppercase tracking-wider">WhatsApp</p>
                  <p className="text-sm font-bold text-green-950 group-hover:text-green-700">
                    +62 812 1234 5678
                  </p>
                </div>
              </Button>

              {/* Facebook */}
              <Button 
                href="https://facebook.com/bulindoagroteknologi" 
                type="link" 
                target="_blank" 
                className="flex items-center p-4 bg-gray-50 rounded-xl hover:bg-green-50 transition-all group"
                isExternal
              >
                <img 
                  style={{ width: 24, height: 24, marginRight: 12 }} 
                  src="/assets/images/facebook.png" 
                  alt="Facebook" 
                  className="group-hover:scale-110 transition-transform"
                />
                <div>
                  <p className="text-xs text-gray-600 uppercase tracking-wider">Facebook</p>
                  <p className="text-sm font-bold text-green-950 group-hover:text-green-700">
                    PT Bulindo Agro Teknologi
                  </p>
                </div>
              </Button>

              {/* Instagram */}
              <Button 
                href="https://instagram.com/bulindoagroteknologi" 
                type="link" 
                target="_blank" 
                className="flex items-center p-4 bg-gray-50 rounded-xl hover:bg-green-50 transition-all group"
                isExternal
              >
                <img 
                  style={{ width: 24, height: 24, marginRight: 12 }} 
                  src="/assets/images/instagram.png" 
                  alt="Instagram" 
                  className="group-hover:scale-110 transition-transform"
                />
                <div>
                  <p className="text-xs text-gray-600 uppercase tracking-wider">Instagram</p>
                  <p className="text-sm font-bold text-green-950 group-hover:text-green-700">
                    @BulindoAgroTeknologi
                  </p>
                </div>
              </Button>
            </div>
          </div>

        </div>
      </Fade>

      {/* Business Hours Section */}
      <Fade direction="up" triggerOnce delay={400}>
        <div className="max-w-4xl mx-auto mt-12 bg-white bg-opacity-90 rounded-2xl shadow-xl p-8 text-center">
          <h3 className="text-2xl font-bold text-green-900 mb-6">
            {t('businessHours')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-green-950">
            <div className="flex justify-between items-center border-b border-gray-300 pb-3">
              <span className="font-semibold">{t('mondayFriday')}</span>
              <span className="text-green-700 font-bold">08:00 - 17:00</span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-300 pb-3">
              <span className="font-semibold">{t('saturday')}</span>
              <span className="text-green-700 font-bold">08:00 - 13:00</span>
            </div>
            <div className="flex justify-between items-center md:col-span-2 border-b border-gray-300 pb-3">
              <span className="font-semibold">{t('sundayHolidays')}</span>
              <span className="text-red-600 font-bold">{t('closed')}</span>
            </div>
          </div>
          <p className="mt-6 text-sm text-gray-600 italic">
            {t('contactNote')}
          </p>
        </div>
      </Fade>

    </section>
  );
};
